<ng-template #content let-c="close" let-d="dismiss">
    <!--<div class="modal-header border-0">
        <h4 class="modal-title text-center" >
            Use of Scout - Important Instructions
        </h4>
    </div>-->
    <div class="modal-body">
        <h4 class="text-left consent-title">
            Use of PodLabs - Disclaimer
        </h4>
        <p>
            Welcome, before you begin, please read the following instructions and disclaimers carefully:

        </p>
        <ul class="bullet-points">
            <li class="mb-3">
                <span class="sub-heading text-primary">AI-Generated Content:</span> The audio produced by this tool is generated using artificial intelligence. While we strive for high quality, the content may not always reflect accurate or up-to-date information. Users must verify facts independently.
            </li>
            <li class="mb-3">
                <span class="sub-heading text-primary"> Representation:</span> The voices used by our tool are synthetic and do not represent real individuals. Any similarity to actual persons, living or dead, is purely coincidental.
            </li>
            <li class="mb-3">
                <span class="sub-heading text-primary">Retention Period:</span> Audio files will be retained for a period of 7 days from the time the podcast is generated.
            </li>
            <li class="mb-3">
                <span class="sub-heading text-primary">Limitations of the Technology:</span> The generated audio may lack emotional nuance and human-like expression. Listeners may perceive the content differently, and we recommend considering the context in which it is presented.
            </li>
            <li class="mb-3">
                <span class="sub-heading text-primary"> Misinformation Potential:</span> As with any automated system, there is a risk of generating misleading or incorrect information. Users are responsible for the content they create and should use the tool cautiously.
            </li>
            <li class="mb-3">
                <span class="sub-heading text-primary">User Responsibility:</span> By using this tool, you acknowledge that you understand the limitations of AI-generated audio content and agree to create and share material at that does not contain Genpact/ Client Confidential and Personally Identifiable Information (PII). Only documents hosted on the Genpact network and that Genpact has contractual permission to maintain on the Genpact network may be uploaded here.
            </li>
            <li class="mb-3">
                <span class="sub-heading text-primary">Intellectual Property:</span> Users are responsible for ensuring that any text input complies with copyright laws. The tool does not provide legal advice regarding content ownership or rights.
            </li>
            <li class="mb-3">
                Kindly note that your inputs maybe subject to audit and may be used for refining the accuracy of responses provided by tool.
            </li>
            <li class="mb-3">
                Feedback and Support: We welcome your feedback and are here to assist you. 
                If you have questions or concerns about our tool, please reach out through {{'['}}
                <a href="mailto:GenpactAIOPSSupport@genpact.com">{{'GenpactAIOPSSupport@genpact.com'}}</a>
                {{']'}}
            </li>
           
        </ul>
        <form [formGroup]="form">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="agreeCheckbox" tabindex="1" formControlName="agree" ngbAutofocus>
                <label class="form-check-label" for="agreeCheckbox">
                    I acknowledge that I have read, understand and agree to above instructions and disclaimers.
                </label>
            </div>
            <div class="d-flex justify-content-center">
                <button class="btn btn-primary-light mt-3 btn-md fw-500" (click)="proceed()" [disabled]="!form.get('agree')?.value">
                    Proceed
                </button>
            </div>
        </form>
    </div>
</ng-template>